import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InfoIcon, Play } from "lucide-react";
import React from "react";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";


const weekInfo = [
    {
      id: 1,
      title: "Building The Ultimate Profile",
      description: "CV + LinkedIn revamp to make your application stand out",
    },
    {
      id: 2,
      title: "Creating Your Job Hunt Plan",
      description: "Learn winning strategies that will get you shortlisted",
    },
  
    {
      id: 3,
      title: "Mastering The Elevator Pitch",
      description:
        "Land multiple job interviews with the right skills & attitude",
    },
    {
      id: 4,
      title: "Live Interview Training",
      description: "Get hired with mock interviews & personalised feedback",
    },
  ];

const CareerGuidanceFeature = ({ stepNumber = 2, onExploreClick , weekModalInfo, setYoutubeModal , setShowModal }) => {
  return (
    <div className="backdrop-blur-[7.5px] bg-[rgba(64,106,255,0.05)] flex flex-col items-center pb-6 pt-0 px-6 relative rounded-xl w-full shadow-[0px_-4px_20px_0px_rgba(0,0,0,0.3)]">
      {/* Top decorative element */}
      <img 
        alt="" 
        className="w-full -mt-5 h-[50px]" 
        src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Ellipse%201270.png"
      />

      {/* Main content container */}
      <div className="flex flex-col gap-4 items-center relative w-full">
        {/* Header section with step number and title */}
        <div className="flex flex-col gap-3 items-center relative w-full">
          {/* Step number badge */}
          <div className="border-[#c1dcff] border-[1.5px] border-solid flex items-center justify-center p-[10px] relative rounded-[24px] w-6 h-6">
            <p 
              className="font-bold text-[14px] leading-none tracking-[-0.14px] font-['Inter']"
              style={{
                background: "linear-gradient(180deg, #c1dcff 0%, #406aff 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
              }}
            >
              {stepNumber}
            </p>
          </div>

          {/* Title and description */}
          <div className="flex flex-col gap-[6px] items-center w-full">
            <h2 
              className="font-bold text-[16px] flex items-center leading-none tracking-[-0.16px] text-center font-['Inter'] capitalize"
              style={{
                background: "linear-gradient(90deg, rgba(193, 220, 255, 1) 0%, rgba(13, 91, 249, 1) 117.87%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
              }}
            >
              100% Placement Support <InfoIcon size={20} className="text-white ml-1 cursor-pointer" onClick={()=>
                {
                    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_PLACEMENT_SUPPORT_WEEK_MODAL_OPENED);
                    setShowModal(true)
                }}/>
            </h2>
            
            <p className="font-normal text-[12px] leading-[1.4] text-center text-[rgba(255,255,255,0.7)] font-['Inter'] whitespace-pre-wrap max-w-full">
            A lifetime placement assistance as a valued LearnTube Learner
            </p>
          </div>
        </div>

        <div className="w-full md:w-[80%] flex items-center justify-center gap-4">
            <img alt="" src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Stats/Frame%20427322005.webp" className="w-[30%]"/>
            <div className="flex-1 flex flex-col items-center justify-center gap-2">
            {
                        weekInfo?.map((item,index) => (
                            <div key={item?.index} className="flex flex-col justify-start items-start w-full cursor-pointer" onClick={()=> 
                            {
                                Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_PLACEMENT_SUPPORT_WEEK_MODAL_OPENED);
                                setYoutubeModal({info : weekModalInfo[index] , is_open : true})
                            }}>
                                <div className="py-0 pr-0 rounded-3xl w-full" >
                                    <div className="py-2 px-4  rounded-3xl flex justify-between items-center"  style={{
                                      boxShadow:`4px 4px 7px 0 rgba(11, 29, 43, 0.7)`,
                                      backgroundImage :`linear-gradient(
    to right,
    rgba(64, 106, 255, 0.2) 0%,
    rgba(38, 64, 153, 0.2) 100%
  )`}}>
                                        <div className="w-full text-left">
                                            <div className="text-[9px] md:text-[11px] font-bold text-[#70AEFF]">WEEK {index+1}</div>
                                            <div className="text-[10px] md:text-[12px] text-white font-medium mt-1">{item?.title}<FontAwesomeIcon icon={faPlay} className="text-white ml-1 md:ml-2" /></div>
                                        </div>
                                    
                                    </div>
                                </div>
                            </div>))
                }
            </div>
        </div>

        <div className="w-full md:w-[80%] text-[10px] text-white/50  flex whitespace-nowrap gap-4">
        & Others From <img alt="" className="w-full" src="https://assets.learntube.ai/files/academy%20placement/Frame%20427322287.svg"/>
        </div>
      </div>
    </div>
  );
};

export default CareerGuidanceFeature;
